<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('bid')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <el-tooltip
            placement="top"
            :effect="themeMode.darkMode == true ? 'light' : 'dark'"
            :content="$t('instruction')">
             <button
              type="button"
              class="btn btn-primary btn-sm"
              data-toggle="modal"
              @click="instructionOpen">
              <!-- {{ $t("instruction") }} -->
              <app-icon name="book-open" />
            </button>

          </el-tooltip>
          <el-tooltip
            placement="top"
            :effect="themeMode.darkMode == true ? 'light' : 'dark'"
            :content="$t('assign_bid_form_modal')">
              <button
                type="button"
                class="btn btn-primary btn-with-shadow"
                data-toggle="modal"
                @click="openAddEditModal">
                {{ $t("assign_bid_form") }}
              </button>
          </el-tooltip>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 mb-2" v-if="instructionShow == true">
        <div class="alert alert-info" role="alert">
          <button type="button" class="close" @click.prevent="instructionClose">
            <h5 aria-hidden="true">&times;</h5>
          </button>
          <!-- <hr> -->
          <h5 class="alert-heading"><app-icon name="book-open" /> {{ $t("instructions_about_job_bid") }}</h5>
          <p class="mb-0">{{ $t("introduction_job_bid") }}</p>
          <strong>Actions:</strong>
          <ul>
            <li><strong>{{ $t("accept") }} :</strong> {{ $t("accept_action") }}</li>
            <li><strong>{{ $t("reject") }} :</strong> {{ $t("reject_action") }}</li>
            <li><strong>{{ $t("view_more") }} :</strong> {{ $t("view_more_action") }}</li>
          </ul>
        </div>
      </div>
    </div>

    <div clasa="row">
      <div class="col-12">
        <h4>Assigned Bid Form</h4>
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="bidForm.length > 0">
              <th>{{ bidForm[0].get_forms.name }}</th>
              <td>{{ bidForm[0].get_forms.description }}</td>
              <td>
                <a href="" @click.prevent="viewForm(bidForm[0].form_body_id)" class="cursor-pointer	link-primary">View</a>,
                <a href="" @click.prevent="openAddEditModal()" class="cursor-pointer	link-primary">Change Bid Form</a>
              </td>
            </tr>
            <tr v-else>
              <th colspan="3" class="text-center">{{ $t('no_bid_form_assign') }}</th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card card-with-search border-0 card-with-shadow">
      <div class="text-justify">
          <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>
    </div>
    <job-bidaddmodal
      v-if="isAddEditModalActive"
      :id="job_id"
      @close-modal="closeAddEditModal"
    />
    <bid-formviewmodal
      v-if="isBidFormViewModalActive"
      :form_body_id="form_body_id"
      @close-modal="closeBidFormViewModal"
    />
  </div>
</template>
<script>
import CopyButton from "../../../Demo/UI/CopyButton.vue";
import { axiosGet} from "../../../../../../app/Helpers/AxiosHelper";
import * as actions from "../../../../../Config/ApiUrl";

export default {
  name: "FormGrid",
  components: { CopyButton },
  props: {
    id: Number,
  },
  data() {
    return {
      bidForm: {},
      form_body_id: 0,
      isBidFormViewModalActive: false,
      instructionShow: false,
      isAddEditModalActive: false,
      job_id:0,
      tabsHorizontal: [
        {
          icon: "users",
          name: "All Bids",
          component: "job-bids-pending",
          permission: "",
          props: {id:this.id, status:''}
        },
        {
          icon: "users",
          name: "Pending Bids",
          component: "job-bids-pending",
          permission: "",
          props: {id:this.id, status:'pending'}
        },
        {
          icon: "info",
          name: "Accepted Bids",
          component: "job-bids-pending",
          permission: "",
          props: {id:this.id, status:'accepted'}
        },
        {
          icon: "link",
          name: "Rejected Bids",
          component: "job-bids-pending",
          permission: "",
          props: {id:this.id, status:'rejected'}
        },
      ],
    };
  },
  methods: {
    instructionOpen() {
      this.instructionShow = true;
    },
    instructionClose() {
      this.instructionShow = false;
    },
    openAddEditModal() {
      this.job_id =this.id;
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.getBidForm();
    },
    getBidForm() {

      axiosGet(`${actions.BID_FORM_VIEW}/${this.id}`)
        // axiosGet(`admin/job/bid/form/2?form_id=${form_id}`)
        .then((res) => {
          this.bidForm = res.data;
        })
        .catch((res) => {
          console.error(res);
        });
    },
    viewForm(id) {
      this.form_body_id = id;
      this.isBidFormViewModalActive = true;
    },
    closeBidFormViewModal() {
      $("#bid-form-view-Modal").modal("hide");
      this.isBidFormViewModalActive = false;
    },
  },
  mounted() {
    this.getBidForm();
  },
  computed: {
    themeMode() {
      return this.$store.state.theme;
    },
  },
};
</script>
